import { createFileRoute } from '@tanstack/react-router';
import { RelatorioFinanceiroContasReceber } from '@/features/relatorio/page/financeiro/contas-receber/RelatorioFinanceiroContasReceber';

export const Route = createFileRoute('/a/relatorio/financeiro/contas-receber')({
    component: RelatorioFinanceiroContasReceber,
});
